import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-ktostamm-kunde-master-view',
  imports: [],
  templateUrl: './ktostamm-kunde.master-view.html',
  styleUrls: ['./ktostamm-kunde.master-view.css'],
})
export class KtostammKundeMasterView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
